import React from 'react';
import { css } from 'aphrodite';
import { withRouter } from 'react-router-dom';
import styles from '../button-styles';
import '../button-loading-styles.css';
import gbStyles from './green-button-styles';
import buttonClick from '../button-click';

const GreenButton = (props) => (
  <div className={css(styles.root, gbStyles.root, props.loading && styles.rootLoading, props.disabled && styles.rootDisabled)} onClick={buttonClick(props)}>
    <div className={css(styles.title, gbStyles.title, props.loading && styles.titleLoading)}>{props.title}</div>
    {props.loading && <div className={'loading'} style={{ position: 'absolute', top: 3, texAlign: 'center' }}>
      <span>.</span><span>.</span><span>.</span>
    </div>}
  </div>
);

export default withRouter(GreenButton);



// WEBPACK FOOTER //
// ./src/components/common/button/green-button/green-button.js